import { TargetBase } from "./Targets/Target";
import { TargetZone } from "./TargetZone";


/**
 * Zaznam o zasahu terce
 */
export class TargetHitEntry {
    /**
     * Pozice mice pri zasahu
     */
    ballPos: pc.Vec2;
    /**
     * Zasazeny terc
     */
    target: TargetBase;
    /**
     * Pozice terce
     */
    targetPos: pc.Vec2;
    /**
     * Polomer terce v dobe kolize
     */
    targetRadius: number;
    /**
     * Pozice zasahu do terce v pomeru k polomeru terce
     */
    hitRadiusRatio: number;
    /**
     * Zona zasazeneho terce nebo undefined, pokud terc nema zony
     */
    zone: TargetZone;
    /**
     * Skore za zasah
     */
    rawScore: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(ballPos: pc.Vec2, target: TargetBase, targetPos: pc.Vec2, targetRadius: number, hitRadiusRatio: number, zone: TargetZone, rawScore: number) {
        this.ballPos = ballPos;
        this.target = target;
        this.targetPos = targetPos;
        this.targetRadius = targetRadius;
        this.hitRadiusRatio = hitRadiusRatio;
        this.zone = zone;
        this.rawScore = rawScore;

        //console.log("hit entry: ballPos: " + ballPos.x + "x" + ballPos.y + " | targetPos: " + targetPos.x + "x" + targetPos.y + " | hit radius ratio: " + hitRadiusRatio);
    }
}